// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3t22d","noInteraction":"EventWrapper_noInteraction__2EdPU"};